import { ComponentProps } from "react";

export type DrawerHeaderProps = ComponentProps<"div">;

export const DrawerHeader = ({ ...props }: DrawerHeaderProps) => {
  return <div {...props} />;
};
